import { Injectable } from '@angular/core';

@Injectable()
export class TrackTeamSubTeamProgressService {
    private storageKey = 'teamsToExcludeSubTeamsProgress';

    constructor() {}

    getExcludedTeams(): string[] {
        const excludedTeamsJson = localStorage.getItem(this.storageKey);
        return excludedTeamsJson ? JSON.parse(excludedTeamsJson) : [];
    }

    addExcludedTeam(teamId: string): void {
        const excludedTeams = this.getExcludedTeams();
        if (!excludedTeams.includes(teamId)) {
            excludedTeams.push(teamId);
            localStorage.setItem(this.storageKey, JSON.stringify(excludedTeams));
        }
    }

    removeExcludedTeam(teamId: string): void {
        const excludedTeams = this.getExcludedTeams();
        const updatedExcludedTeams = excludedTeams.filter((id) => id !== teamId);
        localStorage.setItem(this.storageKey, JSON.stringify(updatedExcludedTeams));
    }

    isTrackTeamSubTeamProgressExcluded(teamId: string): boolean {
        const excludedTeams = this.getExcludedTeams();
        return excludedTeams.includes(teamId);
    }
}
